import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "scan-content" }
const _hoisted_3 = { class: "content-scan-area" }
const _hoisted_4 = { class: "scan-camera" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]

import { ref } from 'vue';
  import h5Config from '@/config/config';
  import { reactive, onMounted, onUnmounted } from 'vue';
  import { Html5Qrcode } from 'html5-qrcode';
  import { showToast } from 'vant';
  import scanAudioUrl from '@/assets/sounds/scan_audio.mp3';
  import jsQR from 'jsqr';
  import router from '@/router';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ScanView',
  setup(__props) {

  const audioElement = ref(null);
  const state = reactive({
    html5QrCode: null,
    fileList: [],
    previewImage: null,
    currentFileName: '',
    currentFileSize: '',
    isFlashOn: false, // 闪光灯状态
  });

  const playSound = () => {
    if (audioElement.value) {
      audioElement.value.src = scanAudioUrl;
      audioElement.value.play();
    }
  };

  const goBack = () => {
    if (state.html5QrCode?.isScanning) {
      stopScan();
    }
    router.replace('/');
  };

  onMounted(() => {
    // 设置音频源
    if (audioElement.value) {
      audioElement.value.src = scanAudioUrl;
    }
    getCamerasInfo();
  });
  onUnmounted(() => {
    if (state.html5QrCode?.isScanning) {
      stopScan();
    }
  });

  const getCamerasInfo = () => {
    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          state.html5QrCode = new Html5Qrcode('qr-reader');
          startScan();
        }
      })
      .catch((err) => {
        showToast({
          message: '摄像头无访问权限！',
          duration: 2000,
        });
      });
  };

  const startScan = () => {
    state.html5QrCode
      .start(
        { facingMode: 'environment' },
        {
          fps: 20,
          qrbox: { width: 250, height: 250 },
        },
        (decodedText, decodedResult) => {
          playSound();
          // showToast(decodedText, decodedResult);
          // router.replace('/?' + decodedText);
          // router.push(decodedText);
          // showToast(decodedText.replace(window.location.origin, ''));
          router.replace(decodedText.replace(window.location.origin, ''));
          // window.location.href = decodedText;
        },
      )
      .catch((err) => {
        console.log('扫码失败', err);
      });
  };

  const stopScan = () => {
    state.html5QrCode
      .stop()
      .then((a) => {
        console.log('已停止扫码', a);
      })
      .catch((err) => {
        console.log(err);
        showToast('停止失败');
      });
  };

  // 获取图片的EXIF方向信息
  const getImageOrientation = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xffd8) {
          resolve(-2); // 不是JPEG
          return;
        }
        const length = view.byteLength;
        let offset = 2;
        while (offset < length) {
          if (view.getUint16(offset + 2, false) <= 8) {
            resolve(-1); // 无效
            return;
          }
          const marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xffe1) {
            if (view.getUint32((offset += 2), false) !== 0x45786966) {
              resolve(-1);
              return;
            }
            const little = view.getUint16((offset += 6), false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            const tags = view.getUint16(offset, little);
            offset += 2;
            for (let i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                resolve(view.getUint16(offset + i * 12 + 8, little));
                return;
              }
            }
          } else if ((marker & 0xff00) !== 0xff00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        resolve(-1);
      };
      reader.readAsArrayBuffer(file);
    });
  };

  // 根据EXIF方向旋转图片
  const rotateImageByOrientation = (canvas, ctx, orientation) => {
    const width = canvas.width;
    const height = canvas.height;

    switch (orientation) {
      case 2:
        // 水平翻转
        ctx.transform(-1, 0, 0, 1, width, 0);
        break;
      case 3:
        // 180度旋转
        ctx.transform(-1, 0, 0, -1, width, height);
        break;
      case 4:
        // 垂直翻转
        ctx.transform(1, 0, 0, -1, 0, height);
        break;
      case 5:
        // 顺时针90度+水平翻转
        canvas.width = height;
        canvas.height = width;
        ctx.transform(0, 1, 1, 0, 0, 0);
        break;
      case 6:
        // 顺时针90度
        canvas.width = height;
        canvas.height = width;
        ctx.transform(0, 1, -1, 0, height, 0);
        break;
      case 7:
        // 逆时针90度+水平翻转
        canvas.width = height;
        canvas.height = width;
        ctx.transform(0, -1, -1, 0, height, width);
        break;
      case 8:
        // 逆时针90度
        canvas.width = height;
        canvas.height = width;
        ctx.transform(0, -1, 1, 0, 0, width);
        break;
      default:
        // 不需要旋转
        break;
    }
  };

  // 将文件转换为ImageData用于jsQR识别
  const fileToImageData = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const reader = new FileReader();
      reader.onload = (e) => {
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          resolve(imageData);
        };
        img.onerror = () => reject(new Error('图片加载失败'));
        img.src = e.target.result;
      };
      reader.onerror = () => reject(new Error('文件读取失败'));
      reader.readAsDataURL(file);
    });
  };

  // 使用jsQR识别二维码
  const scanWithJsQR = async (file) => {
    const imageData = await fileToImageData(file);

    // 尝试多种jsQR配置
    const jsQRConfigs = [
      {
        name: '标准模式',
        options: { inversionAttempts: 'dontInvert' },
      },
      {
        name: '反色模式',
        options: { inversionAttempts: 'onlyInvert' },
      },
      {
        name: '自动尝试',
        options: { inversionAttempts: 'attemptBoth' },
      },
      {
        name: '严格模式',
        options: {
          inversionAttempts: 'attemptBoth',
          canOverwriteImage: true,
        },
      },
    ];

    for (let i = 0; i < jsQRConfigs.length; i++) {
      const { name, options } = jsQRConfigs[i];

      try {
        const code = jsQR(imageData.data, imageData.width, imageData.height, options);

        if (code) {
          return code.data;
        }
      } catch (configError) {
        // 继续尝试下一个配置
      }
    }

    throw new Error('jsQR 所有配置都未检测到二维码');
  };

  // 快速高效预处理 (只保留最有效的3种)
  const quickEnhancedPreprocessing = async (file) => {
    const orientation = await getImageOrientation(file);

    return new Promise((resolve, reject) => {
      const img = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const reader = new FileReader();
      reader.onload = (e) => {
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;

          // 处理图片方向
          if (orientation > 1) {
            rotateImageByOrientation(canvas, ctx, orientation);
          }

          ctx.drawImage(img, 0, 0);
          const results = [];

          // 方法1: 智能二值化 (最有效)
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          // 快速Otsu阈值计算
          let histogram = new Array(256).fill(0);
          for (let i = 0; i < data.length; i += 4) {
            const gray = Math.round((data[i] + data[i + 1] + data[i + 2]) / 3);
            histogram[gray]++;
          }

          let maxVariance = 0;
          let threshold = 128;
          const totalPixels = canvas.width * canvas.height;

          for (let t = 50; t < 200; t += 5) {
            // 加快计算，减少循环
            let w1 = 0,
              w2 = 0,
              sum1 = 0,
              sum2 = 0;

            for (let i = 0; i < t; i++) {
              w1 += histogram[i];
              sum1 += i * histogram[i];
            }
            for (let i = t; i < 256; i++) {
              w2 += histogram[i];
              sum2 += i * histogram[i];
            }

            if (w1 > 0 && w2 > 0) {
              const mean1 = sum1 / w1;
              const mean2 = sum2 / w2;
              const variance = (w1 * w2 * (mean1 - mean2) * (mean1 - mean2)) / totalPixels;

              if (variance > maxVariance) {
                maxVariance = variance;
                threshold = t;
              }
            }
          }

          // 应用二值化
          for (let i = 0; i < data.length; i += 4) {
            const gray = (data[i] + data[i + 1] + data[i + 2]) / 3;
            const value = gray > threshold ? 255 : 0;
            data[i] = data[i + 1] = data[i + 2] = value;
          }

          ctx.putImageData(imageData, 0, 0);
          canvas.toBlob(
            (blob1) => {
              results.push({ blob: blob1, format: '智能二值化' });

              // 方法2: 简单去摩尔纹
              const blurCanvas = document.createElement('canvas');
              const blurCtx = blurCanvas.getContext('2d');
              blurCanvas.width = canvas.width;
              blurCanvas.height = canvas.height;

              blurCtx.filter = 'blur(0.8px) contrast(1.2)';
              blurCtx.drawImage(img, 0, 0);
              blurCtx.filter = 'none';

              blurCanvas.toBlob(
                (blob2) => {
                  results.push({ blob: blob2, format: '去摩尔纹' });

                  // 方法3: 极限对比度
                  const contrastCanvas = document.createElement('canvas');
                  const contrastCtx = contrastCanvas.getContext('2d');
                  contrastCanvas.width = canvas.width;
                  contrastCanvas.height = canvas.height;

                  contrastCtx.filter = 'contrast(1.8) brightness(1.1) saturate(0)';
                  contrastCtx.drawImage(img, 0, 0);
                  contrastCtx.filter = 'none';

                  contrastCanvas.toBlob(
                    (blob3) => {
                      results.push({ blob: blob3, format: '极限对比' });
                      resolve(results);
                    },
                    'image/jpeg',
                    0.9,
                  );
                },
                'image/jpeg',
                0.9,
              );
            },
            'image/jpeg',
            0.9,
          );
        };

        img.onerror = () => reject(new Error('图片加载失败'));
        img.src = e.target.result;
      };

      reader.onerror = () => reject(new Error('文件读取失败'));
      reader.readAsDataURL(file);
    });
  };

  // 图片缩放函数
  const resizeImage = (file, maxWidth) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const reader = new FileReader();
      reader.onload = (e) => {
        img.onload = () => {
          // 计算缩放比例
          let { width, height } = img;

          if (width > maxWidth) {
            const ratio = maxWidth / width;
            width = maxWidth;
            height = height * ratio;
          }

          if (height > maxWidth) {
            const ratio = maxWidth / height;
            height = maxWidth;
            width = width * ratio;
          }

          canvas.width = width;
          canvas.height = height;

          // 使用高质量缩放
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              resolve(blob);
            },
            file.type,
            0.9,
          );
        };
        img.onerror = () => reject(new Error('图片加载失败'));
        img.src = e.target.result;
      };
      reader.onerror = () => reject(new Error('文件读取失败'));
      reader.readAsDataURL(file);
    });
  };

  // 获取图片尺寸
  const getImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.onload = () => {
          resolve({
            width: img.width,
            height: img.height,
          });
        };
        img.onerror = () => reject(new Error('无法加载图片'));
        img.src = e.target.result;
      };

      reader.onerror = () => reject(new Error('文件读取失败'));
      reader.readAsDataURL(file);
    });
  };

  const uploadImg = async () => {
    try {
      if (!state.fileList || state.fileList.length === 0) {
        showToast({
          message: '请选择图片！',
          duration: 2000,
        });
        return;
      }

      const fileInfo = state.fileList[0];
      const originalFile = fileInfo.file; // 保存原始文件信息
      let file = originalFile; // 使用let，可能会被压缩后的文件替换

      // 保存原始文件信息，防止压缩后丢失
      const originalFileName = originalFile.name;
      const originalFileSize = originalFile.size;
      const originalFileType = originalFile.type;
      const originalLastModified = originalFile.lastModified;

      // 清除之前的预览（防止显示旧图片）
      clearPreview();

      // 设置图片预览
      const reader = new FileReader();
      reader.onload = (e) => {
        state.previewImage = e.target.result;
        state.currentFileName = originalFileName;
        state.currentFileSize = `${Math.round(originalFileSize / 1024)}KB`;
      };
      reader.readAsDataURL(originalFile);

      // 🚀 智能图片压缩 - 优先处理大图片
      const shouldCompress = originalFileSize > 1000000; // 大于1MB
      console.log(shouldCompress);
      if (shouldCompress) {
        // showToast('大图片压缩中...');

        try {
          // 获取图片尺寸
          const imgDimensions = await getImageDimensions(originalFile);

          // 确定目标尺寸
          let targetSize = 1000; // 默认最大边1000px
          if (originalFileSize > 5000000) {
            // 超过5MB
            targetSize = 800;
          } else if (originalFileSize > 3000000) {
            // 超过3MB
            targetSize = 900;
          }

          // 压缩图片
          const compressedBlob = await resizeImage(originalFile, targetSize);

          // 创建新的File对象，保留原始文件的属性
          file = new File([compressedBlob], originalFileName, {
            type: originalFileType,
            lastModified: originalLastModified,
          });

          // showToast(`压缩完成: ${Math.round(file.size / 1024)}KB`);

          // 更新预览信息
          state.currentFileSize = `${Math.round(file.size / 1024)}KB (已压缩)`;
        } catch (compressError) {
          // showToast('压缩失败，使用原图');
          file = originalFile; // 压缩失败时使用原图
        }
      }

      // 如果摄像头正在扫码，先停止
      let wasScanning = false;
      if (state.html5QrCode && state.html5QrCode.isScanning) {
        wasScanning = true;
        await state.html5QrCode.stop();
      }

      // 判断是否为拍照图片（使用原始文件信息）
      const isLikelyFromCamera =
        originalFileSize > 500000 ||
        originalLastModified > Date.now() - 10000 ||
        originalFileName.includes('image') ||
        originalFileName.includes('IMG') ||
        originalFileName.toLowerCase().includes('camera');

      // 判断是否为屏幕拍照（使用原始文件信息）
      const isLikelyScreenPhoto =
        originalFileName.toLowerCase().includes('screenshot') ||
        originalFileName.toLowerCase().includes('screen') ||
        originalFileSize > 2000000 || // 大于2MB
        (originalFileSize > 1000000 && originalFileType === 'image/png'); // 大PNG文件

      let result;
      console.log(isLikelyScreenPhoto);

      if (isLikelyScreenPhoto) {
        // showToast('检测到屏幕拍照，使用高效策略...');

        try {
          // 策略1: 直接用jsQR尝试原图 (最快)
          const directResult = await scanWithJsQR(file);
          result = directResult;
        } catch (directError) {
          try {
            // 策略2: 快速预处理 + jsQR (最有效的几种)
            const quickResults = await quickEnhancedPreprocessing(file);

            for (let i = 0; i < quickResults.length; i++) {
              const { blob, format } = quickResults[i];
              // showToast(`${format}处理中...`);

              try {
                const qrResult = await scanWithJsQR(blob);
                result = qrResult;
                break;
              } catch (error) {
                // 继续尝试下一个处理方法
              }
            }

            if (!result) {
              // 策略3: Html5Qrcode备用
              try {
                const html5Result = await state.html5QrCode.scanFile(file, true);
                result = html5Result;
              } catch (html5Error) {
                throw new Error('所有快速处理策略都失败');
              }
            }
          } catch (quickError) {
            throw new Error('处理失败');
          }
        }
      } else if (isLikelyFromCamera) {
        // showToast('检测到拍照图片，高效识别...');

        try {
          // 拍照图片也优先用jsQR（压缩后速度更快）
          result = await scanWithJsQR(file);
        } catch (jsQRError) {
          try {
            result = await state.html5QrCode.scanFile(file, true);
          } catch (html5Error) {
            throw new Error('识别失败');
          }
        }
      } else {
        // 相册图片直接识别
        // showToast('识别相册图片...');
        result = await state.html5QrCode.scanFile(file, true);
      }

      // 🎉 识别成功 - 显示结果并重置状态
      // showToast({
      //   message: `扫码成功: ${result}`,
      //   duration: 2000,
      // });

      router.replace('/category');

      // 延迟清除预览，让用户看到成功信息
      setTimeout(() => {
        clearPreview();
        resetUploadState();
      }, 2000);

      // 恢复摄像头扫码
      if (wasScanning && state.html5QrCode) {
        setTimeout(() => {
          startScan();
        }, 3000);
      }
    } catch (scanError) {
      let errorMessage = '识别失败！';
      let suggestions = [];

      if (scanError.message && scanError.message.includes('No MultiFormat Readers')) {
        errorMessage = '未检测到二维码';
        suggestions = [
          '• 确保二维码完整清晰',
          '• 光线充足，避免反光',
          '• 手机保持稳定',
          '• 二维码不要过小或过大',
          '• 尝试调整拍照角度',
        ];
      }

      showToast({
        message: `${errorMessage}\n\n建议：\n${suggestions.join('\n')}`,
        duration: 5000,
      });

      // 识别失败时也要清除预览
      setTimeout(() => {
        clearPreview();
        resetUploadState();
      }, 5000);
    } finally {
      // 确保状态被重置
      setTimeout(() => {
        resetUploadState();
      }, 6000);
    }
  };

  const beforeRead = (file) => {
    // 清除之前的状态，确保新上传覆盖旧的
    clearPreview();
    resetUploadState();

    // 验证文件类型
    if (!file.type.startsWith('image/')) {
      showToast({
        message: '请选择图片文件！',
        duration: 2000,
      });
      return false;
    }

    // 验证文件大小 (30MB限制)
    if (file.size > 30 * 1024 * 1024) {
      showToast({
        message: '图片不能超过30MB！',
        duration: 2000,
      });
      return false;
    }

    return true;
  };

  const clearPreview = () => {
    state.previewImage = null;
    state.currentFileName = '';
    state.currentFileSize = '';
  };

  const resetUploadState = () => {
    state.fileList = [];
  };

  // 切换闪光灯
  const clickFlash = async () => {
    if (!state.html5QrCode) {
      showToast({
        message: '请先启动扫码功能！',
        duration: 2000,
      });
      return;
    }

    try {
      // 切换闪光灯状态
      state.isFlashOn = !state.isFlashOn;

      // 应用闪光灯设置
      await state.html5QrCode.applyVideoConstraints({
        advanced: [
          {
            torch: state.isFlashOn,
          },
        ],
      });

      showToast({
        message: state.isFlashOn ? '闪光灯已开启' : '闪光灯已关闭',
        duration: 1500,
      });
    } catch (error) {
      // 如果设备不支持闪光灯，回退状态
      state.isFlashOn = !state.isFlashOn;

      showToast({
        message: '该设备不支持闪光灯功能！',
        duration: 2000,
      });
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", {
      ref_key: "audioElement",
      ref: audioElement
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", { class: "content-header" }, [
          _createElementVNode("a", {
            class: "text-white",
            onClick: goBack
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "fas fa-times text-xl" }, null, -1)
          ])),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-white text-lg font-semibold" }, "扫码点餐", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("button", { class: "text-white right-icon" }, [
            _createElementVNode("i", { class: "text-xl" })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("div", {
              id: "qr-reader",
              class: "qr-reader"
            }, null, -1)),
            (state.previewImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: state.previewImage,
                    alt: "预览图片",
                    style: {"width":"250px","border-width":"18.5px 66px","border-style":"solid"}
                  }, null, 8, _hoisted_6)
                ]))
              : _createCommentVNode("", true),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-white scan-tip" }, [
              _createElementVNode("p", { class: "text-sm" }, "将二维码放入框内，即可自动扫描")
            ], -1))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "footer-action-area" }, null, -1))
        ])
      ])
    ])
  ], 64))
}
}

})